/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1450
 */

var r = require(/* 1431 */"../../../../../../797/101/2466/1167/1431/index")
var i = require(/* 2537 */"./2537")(r)
module.exports = i
